/**
 * @generated SignedSource<<f51a87543b386186d7303f6e38c5d6b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateCateringOptionInput = {
  displayInSearch?: boolean | null;
  etgKey?: string | null;
  name?: string | null;
};
export type CateringEditFormMutation$variables = {
  id: string;
  input: UpdateCateringOptionInput;
};
export type CateringEditFormMutation$data = {
  readonly updateCateringOption: {
    readonly " $fragmentSpreads": FragmentRefs<"CateringEditForm_cateringOption">;
  };
};
export type CateringEditFormMutation = {
  response: CateringEditFormMutation$data;
  variables: CateringEditFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CateringEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CateringOption",
        "kind": "LinkedField",
        "name": "updateCateringOption",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CateringEditForm_cateringOption"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CateringEditFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CateringOption",
        "kind": "LinkedField",
        "name": "updateCateringOption",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "etgKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayInSearch",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "909be417cdfe112b5da88d5fe6027040",
    "id": null,
    "metadata": {},
    "name": "CateringEditFormMutation",
    "operationKind": "mutation",
    "text": "mutation CateringEditFormMutation(\n  $id: ID!\n  $input: UpdateCateringOptionInput!\n) {\n  updateCateringOption(id: $id, input: $input) {\n    ...CateringEditForm_cateringOption\n    id\n  }\n}\n\nfragment CateringEditForm_cateringOption on CateringOption {\n  id\n  name\n  etgKey\n  displayInSearch\n}\n"
  }
};
})();

(node as any).hash = "312a72d3a80a381003959ad1ad6c2022";

export default node;
